import { render } from "./ErrorInfoIcon.vue?vue&type=template&id=3722a40d&scoped=true"
const script = {}

import "./ErrorInfoIcon.vue?vue&type=style&index=0&id=3722a40d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3722a40d"]])

export default __exports__